import type { DoohReportDailyCumulative } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

export type ChartTooltipRow = { label: string; value: string };

export type BuildChartTooltipArgs = {
  title: string;
  rows: ChartTooltipRow[];
};

/** HTML of the chart's shared tooltip: a title and one label / value row per metric. */
export function buildChartTooltipHtml({ title, rows }: BuildChartTooltipArgs): string {
  const rowsHtml = rows
    .map(
      ({ label, value }) =>
        `<span class="coverageFrequencyChart__tooltipLabel">${label}</span><span class="coverageFrequencyChart__tooltipValue">${value}</span>`
    )
    .join('');

  return `<span class="coverageFrequencyChart__tooltip"><span class="coverageFrequencyChart__tooltipTitle">${title}</span><span class="coverageFrequencyChart__tooltipRows">${rowsHtml}</span></span>`;
}

/** The tooltip rows of a day that has a value: reach, coverage and frequency, in that order. */
export function getTooltipRows(
  point: DoohReportDailyCumulative,
  labels: Record<'coverage' | 'frequency' | 'reach', string>,
  format: Record<'coverage' | 'frequency' | 'reach', (value: number) => string>
): ChartTooltipRow[] {
  return (['reach', 'coverage', 'frequency'] as const).flatMap(metric => {
    const value = point[metric];
    return value === null ? [] : [{ label: labels[metric], value: format[metric](value) }];
  });
}
